<template>
  <div style="text-align: left; display: flex; flex-direction: row; justify-content: space-between; align-items: center;  border: 0px solid #383838;">    
    
    <img 
        alt="Don Quijote Recepciones Logo" 
        :src="'https://donquijote.b-cdn.net/dq-black-logo.png'" 
        style="max-width: 100px; ">

    <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
      <el-menu 
        mode="horizontal" 
        @select="handleSelect" 
        style="margin-top: -10px;">
        <el-submenu 
          :index="'settings'"
          style="font-size: 12px; font-weight: bold; color: black;">
          <template slot="title"><span style="margin-left: 5px;">{{$store.state.events.props.client.name}}</span></template>
            <el-menu-item 
              :router="true"
              :index="'/logout'" style="text-align: left;">
              Logout
            </el-menu-item>           
        </el-submenu>
      </el-menu>
    </div>

  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
    data() {
      return {
        activeIndex: '1',
        show_calendar: false,
        production_calendar: false,
        show_renew: true,
        show_menu: false,
        show_stock_search: false,
        current_path: '/'
      }
    },
    computed: {
      getTopLogo() {
        let retailLogo = ''
        this.$store.getters.getAccessibleStoreList.forEach(element => {
            if(element.retail && retailLogo.length === 0) {
                retailLogo = element.brand_logo
            }
        })
        if(retailLogo.length === 0) {
            retailLogo = 'https://etacdn.b-cdn.net/eta-small.png'
        }
        localStorage.setItem('default_logo', retailLogo)
        return retailLogo
      },
      getDaysLeft() {
        return this.$store.state.master.days_left
      },
      isMobileDevice() {
        return isMobile
      },
      getCurrentRoute() {
        return this.current_path
      },
      isProductionCalendar() {
        return this.production_calendar
      }
    },
    methods: {
        displayMenu() {
          if(this.isMobileDevice) {
            this.show_menu = !this.show_menu
          } else {
            this.show_menu = true
          }
        },
        handleSelect(key) {
            this.handleRouteChange(key)
        },
        handleRouteChange(routePath) {
        this.current_path = routePath
        this.displayMenu()
        let breadcrumbs = []
        if(routePath == "homepage") {
            breadcrumbs.push({
              crumbName: 'Dashboard'
            })
            this.$store.commit('appendBreadcrumbs', breadcrumbs)
            this.$router.push('/')
            this.$store.commit('setAccessRights', {id: 0})
        } else if(routePath == '/logout') {
            this.displayMenu()
            this.logout()
        } else if(routePath == '/changepassword') {
            this.displayMenu()
            breadcrumbs.push({
              crumbName: 'Change Password'
            })
            this.$store.commit('appendBreadcrumbs', breadcrumbs)
            this.$router.push('/changepassword')
        } else if(routePath == '/tasks') {
            this.displayMenu()
            breadcrumbs.push({
              crumbName: 'Tasks'
            })
            this.$store.commit('appendBreadcrumbs', breadcrumbs)
            this.$router.push('/tasks')
        } else if(routePath == 'reachus') {
            console.log("Here")
        } else if(routePath == 'salesCalendar') {
            this.show_calendar = true
            this.production_calendar = false
        } else if(routePath == 'productionCalendar') {
            this.show_calendar = true
            this.production_calendar = true
        } else if(routePath == 'stocksearch') {
            this.displayMenu()
            this.show_stock_search = true
        } else {
          let routeIndex = this.$store.getters.getAllMenus.findIndex((t) => t.route_path == routePath)
          let canMoveForward = false
          if(routeIndex>=0) {
            let routeAccessInfo = this.$store.getters.getAllMenus[routeIndex]
            if(routeAccessInfo.can_view) {
              canMoveForward = true
            }
            this.$store.commit('setAccessRights', routeAccessInfo)
          }
          if(canMoveForward) {
            breadcrumbs.push({
                crumbName: this.$store.getters.getAllMenus[routeIndex].menu_name
            })
            this.$store.commit('appendBreadcrumbs', breadcrumbs)
            this.$router.push(routePath)
          } else {
            this.$store.commit('displayMessageAlert', {message: 'Access Denied', type: 'Error'})    
          }
          
        }
      },
      logout() {
        this.$confirm('Are you sure to logout?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
        }).then(() => {
            this.$store.dispatch('logout')
        }).catch(() => {
                   
        });
      }
    },
    mounted() {
      
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/MainMenu.vue